export interface IChartCard {
    value: string;
    actions: string[];
}

export interface IChartModalCards {
    value: string;
    isActive: boolean;
    isCurrentError: boolean;
}

export const CHART_CARDS: IChartCard[] = [
    { value: "AA", actions: [] },
    { value: "AKs", actions: [] },
    { value: "AQs", actions: [] },
    { value: "AJs", actions: [] },
    { value: "ATs", actions: [] },
    { value: "A9s", actions: [] },
    { value: "A8s", actions: [] },
    { value: "A7s", actions: [] },
    { value: "A6s", actions: [] },
    { value: "A5s", actions: [] },
    { value: "A4s", actions: [] },
    { value: "A3s", actions: [] },
    { value: "A2s", actions: [] },

    { value: "AKo", actions: [] },
    { value: "KK", actions: [] },
    { value: "KQs", actions: [] },
    { value: "KJs", actions: [] },
    { value: "KTs", actions: [] },
    { value: "K9s", actions: [] },
    { value: "K8s", actions: [] },
    { value: "K7s", actions: [] },
    { value: "K6s", actions: [] },
    { value: "K5s", actions: [] },
    { value: "K4s", actions: [] },
    { value: "K3s", actions: [] },
    { value: "K2s", actions: [] },

    { value: "AQo", actions: [] },
    { value: "KQo", actions: [] },
    { value: "QQ", actions: [] },
    { value: "QJs", actions: [] },
    { value: "QTs", actions: [] },
    { value: "Q9s", actions: [] },
    { value: "Q8s", actions: [] },
    { value: "Q7s", actions: [] },
    { value: "Q6s", actions: [] },
    { value: "Q5s", actions: [] },
    { value: "Q4s", actions: [] },
    { value: "Q3s", actions: [] },
    { value: "Q2s", actions: [] },

    { value: "AJo", actions: [] },
    { value: "KJo", actions: [] },
    { value: "QJo", actions: [] },
    { value: "JJ", actions: [] },
    { value: "JTs", actions: [] },
    { value: "J9s", actions: [] },
    { value: "J8s", actions: [] },
    { value: "J7s", actions: [] },
    { value: "J6s", actions: [] },
    { value: "J5s", actions: [] },
    { value: "J4s", actions: [] },
    { value: "J3s", actions: [] },
    { value: "J2s", actions: [] },

    { value: "ATo", actions: [] },
    { value: "KTo", actions: [] },
    { value: "QTo", actions: [] },
    { value: "JTo", actions: [] },
    { value: "TT", actions: [] },
    { value: "T9s", actions: [] },
    { value: "T8s", actions: [] },
    { value: "T7s", actions: [] },
    { value: "T6s", actions: [] },
    { value: "T5s", actions: [] },
    { value: "T4s", actions: [] },
    { value: "T3s", actions: [] },
    { value: "T2s", actions: [] },

    { value: "A9o", actions: [] },
    { value: "K9o", actions: [] },
    { value: "Q9o", actions: [] },
    { value: "J9o", actions: [] },
    { value: "T9o", actions: [] },
    { value: "99", actions: [] },
    { value: "98s", actions: [] },
    { value: "97s", actions: [] },
    { value: "96s", actions: [] },
    { value: "95s", actions: [] },
    { value: "94s", actions: [] },
    { value: "93s", actions: [] },
    { value: "92s", actions: [] },

    { value: "A8o", actions: [] },
    { value: "K8o", actions: [] },
    { value: "Q8o", actions: [] },
    { value: "J8o", actions: [] },
    { value: "T8o", actions: [] },
    { value: "98o", actions: [] },
    { value: "88", actions: [] },
    { value: "87s", actions: [] },
    { value: "86s", actions: [] },
    { value: "85s", actions: [] },
    { value: "84s", actions: [] },
    { value: "83s", actions: [] },
    { value: "82s", actions: [] },

    { value: "A7o", actions: [] },
    { value: "K7o", actions: [] },
    { value: "Q7o", actions: [] },
    { value: "J7o", actions: [] },
    { value: "T7o", actions: [] },
    { value: "97o", actions: [] },
    { value: "87o", actions: [] },
    { value: "77", actions: [] },
    { value: "76s", actions: [] },
    { value: "75s", actions: [] },
    { value: "74s", actions: [] },
    { value: "73s", actions: [] },
    { value: "72s", actions: [] },

    { value: "A6o", actions: [] },
    { value: "K6o", actions: [] },
    { value: "Q6o", actions: [] },
    { value: "J6o", actions: [] },
    { value: "T6o", actions: [] },
    { value: "96o", actions: [] },
    { value: "86o", actions: [] },
    { value: "76o", actions: [] },
    { value: "66", actions: [] },
    { value: "65s", actions: [] },
    { value: "64s", actions: [] },
    { value: "63s", actions: [] },
    { value: "62s", actions: [] },

    { value: "A5o", actions: [] },
    { value: "K5o", actions: [] },
    { value: "Q5o", actions: [] },
    { value: "J5o", actions: [] },
    { value: "T5o", actions: [] },
    { value: "95o", actions: [] },
    { value: "85o", actions: [] },
    { value: "75o", actions: [] },
    { value: "65o", actions: [] },
    { value: "55", actions: [] },
    { value: "54s", actions: [] },
    { value: "53s", actions: [] },
    { value: "52s", actions: [] },

    { value: "A4o", actions: [] },
    { value: "K4o", actions: [] },
    { value: "Q4o", actions: [] },
    { value: "J4o", actions: [] },
    { value: "T4o", actions: [] },
    { value: "94o", actions: [] },
    { value: "84o", actions: [] },
    { value: "74o", actions: [] },
    { value: "64o", actions: [] },
    { value: "54o", actions: [] },
    { value: "44", actions: [] },
    { value: "43s", actions: [] },
    { value: "42s", actions: [] },

    { value: "A3o", actions: [] },
    { value: "K3o", actions: [] },
    { value: "Q3o", actions: [] },
    { value: "J3o", actions: [] },
    { value: "T3o", actions: [] },
    { value: "93o", actions: [] },
    { value: "83o", actions: [] },
    { value: "73o", actions: [] },
    { value: "63o", actions: [] },
    { value: "53o", actions: [] },
    { value: "43o", actions: [] },
    { value: "33", actions: [] },
    { value: "32s", actions: [] },

    { value: "A2o", actions: [] },
    { value: "K2o", actions: [] },
    { value: "Q2o", actions: [] },
    { value: "J2o", actions: [] },
    { value: "T2o", actions: [] },
    { value: "92o", actions: [] },
    { value: "82o", actions: [] },
    { value: "72o", actions: [] },
    { value: "62o", actions: [] },
    { value: "52o", actions: [] },
    { value: "42o", actions: [] },
    { value: "32o", actions: [] },
    { value: "22", actions: [] },
];

export const CHART_MODAL_CARDS: IChartModalCards[] = [
    { value: "AA", isActive: false, isCurrentError: false },
    { value: "AKs", isActive: false, isCurrentError: false },
    { value: "AQs", isActive: false, isCurrentError: false },
    { value: "AJs", isActive: false, isCurrentError: false },
    { value: "ATs", isActive: false, isCurrentError: false },
    { value: "A9s", isActive: false, isCurrentError: false },
    { value: "A8s", isActive: false, isCurrentError: false },
    { value: "A7s", isActive: false, isCurrentError: false },
    { value: "A6s", isActive: false, isCurrentError: false },
    { value: "A5s", isActive: false, isCurrentError: false },
    { value: "A4s", isActive: false, isCurrentError: false },
    { value: "A3s", isActive: false, isCurrentError: false },
    { value: "A2s", isActive: false, isCurrentError: false },

    { value: "AKo", isActive: false, isCurrentError: false },
    { value: "KK", isActive: false, isCurrentError: false },
    { value: "KQs", isActive: false, isCurrentError: false },
    { value: "KJs", isActive: false, isCurrentError: false },
    { value: "KTs", isActive: false, isCurrentError: false },
    { value: "K9s", isActive: false, isCurrentError: false },
    { value: "K8s", isActive: false, isCurrentError: false },
    { value: "K7s", isActive: false, isCurrentError: false },
    { value: "K6s", isActive: false, isCurrentError: false },
    { value: "K5s", isActive: false, isCurrentError: false },
    { value: "K4s", isActive: false, isCurrentError: false },
    { value: "K3s", isActive: false, isCurrentError: false },
    { value: "K2s", isActive: false, isCurrentError: false },

    { value: "AQo", isActive: false, isCurrentError: false },
    { value: "KQo", isActive: false, isCurrentError: false },
    { value: "QQ", isActive: false, isCurrentError: false },
    { value: "QJs", isActive: false, isCurrentError: false },
    { value: "QTs", isActive: false, isCurrentError: false },
    { value: "Q9s", isActive: false, isCurrentError: false },
    { value: "Q8s", isActive: false, isCurrentError: false },
    { value: "Q7s", isActive: false, isCurrentError: false },
    { value: "Q6s", isActive: false, isCurrentError: false },
    { value: "Q5s", isActive: false, isCurrentError: false },
    { value: "Q4s", isActive: false, isCurrentError: false },
    { value: "Q3s", isActive: false, isCurrentError: false },
    { value: "Q2s", isActive: false, isCurrentError: false },

    { value: "AJo", isActive: false, isCurrentError: false },
    { value: "KJo", isActive: false, isCurrentError: false },
    { value: "QJo", isActive: false, isCurrentError: false },
    { value: "JJ", isActive: false, isCurrentError: false },
    { value: "JTs", isActive: false, isCurrentError: false },
    { value: "J9s", isActive: false, isCurrentError: false },
    { value: "J8s", isActive: false, isCurrentError: false },
    { value: "J7s", isActive: false, isCurrentError: false },
    { value: "J6s", isActive: false, isCurrentError: false },
    { value: "J5s", isActive: false, isCurrentError: false },
    { value: "J4s", isActive: false, isCurrentError: false },
    { value: "J3s", isActive: false, isCurrentError: false },
    { value: "J2s", isActive: false, isCurrentError: false },

    { value: "ATo", isActive: false, isCurrentError: false },
    { value: "KTo", isActive: false, isCurrentError: false },
    { value: "QTo", isActive: false, isCurrentError: false },
    { value: "JTo", isActive: false, isCurrentError: false },
    { value: "TT", isActive: false, isCurrentError: false },
    { value: "T9s", isActive: false, isCurrentError: false },
    { value: "T8s", isActive: false, isCurrentError: false },
    { value: "T7s", isActive: false, isCurrentError: false },
    { value: "T6s", isActive: false, isCurrentError: false },
    { value: "T5s", isActive: false, isCurrentError: false },
    { value: "T4s", isActive: false, isCurrentError: false },
    { value: "T3s", isActive: false, isCurrentError: false },
    { value: "T2s", isActive: false, isCurrentError: false },

    { value: "A9o", isActive: false, isCurrentError: false },
    { value: "K9o", isActive: false, isCurrentError: false },
    { value: "Q9o", isActive: false, isCurrentError: false },
    { value: "J9o", isActive: false, isCurrentError: false },
    { value: "T9o", isActive: false, isCurrentError: false },
    { value: "99", isActive: false, isCurrentError: false },
    { value: "98s", isActive: false, isCurrentError: false },
    { value: "97s", isActive: false, isCurrentError: false },
    { value: "96s", isActive: false, isCurrentError: false },
    { value: "95s", isActive: false, isCurrentError: false },
    { value: "94s", isActive: false, isCurrentError: false },
    { value: "93s", isActive: false, isCurrentError: false },
    { value: "92s", isActive: false, isCurrentError: false },

    { value: "A8o", isActive: false, isCurrentError: false },
    { value: "K8o", isActive: false, isCurrentError: false },
    { value: "Q8o", isActive: false, isCurrentError: false },
    { value: "J8o", isActive: false, isCurrentError: false },
    { value: "T8o", isActive: false, isCurrentError: false },
    { value: "98o", isActive: false, isCurrentError: false },
    { value: "88", isActive: false, isCurrentError: false },
    { value: "87s", isActive: false, isCurrentError: false },
    { value: "86s", isActive: false, isCurrentError: false },
    { value: "85s", isActive: false, isCurrentError: false },
    { value: "84s", isActive: false, isCurrentError: false },
    { value: "83s", isActive: false, isCurrentError: false },
    { value: "82s", isActive: false, isCurrentError: false },

    { value: "A7o", isActive: false, isCurrentError: false },
    { value: "K7o", isActive: false, isCurrentError: false },
    { value: "Q7o", isActive: false, isCurrentError: false },
    { value: "J7o", isActive: false, isCurrentError: false },
    { value: "T7o", isActive: false, isCurrentError: false },
    { value: "97o", isActive: false, isCurrentError: false },
    { value: "87o", isActive: false, isCurrentError: false },
    { value: "77", isActive: false, isCurrentError: false },
    { value: "76s", isActive: false, isCurrentError: false },
    { value: "75s", isActive: false, isCurrentError: false },
    { value: "74s", isActive: false, isCurrentError: false },
    { value: "73s", isActive: false, isCurrentError: false },
    { value: "72s", isActive: false, isCurrentError: false },

    { value: "A6o", isActive: false, isCurrentError: false },
    { value: "K6o", isActive: false, isCurrentError: false },
    { value: "Q6o", isActive: false, isCurrentError: false },
    { value: "J6o", isActive: false, isCurrentError: false },
    { value: "T6o", isActive: false, isCurrentError: false },
    { value: "96o", isActive: false, isCurrentError: false },
    { value: "86o", isActive: false, isCurrentError: false },
    { value: "76o", isActive: false, isCurrentError: false },
    { value: "66", isActive: false, isCurrentError: false },
    { value: "65s", isActive: false, isCurrentError: false },
    { value: "64s", isActive: false, isCurrentError: false },
    { value: "63s", isActive: false, isCurrentError: false },
    { value: "62s", isActive: false, isCurrentError: false },

    { value: "A5o", isActive: false, isCurrentError: false },
    { value: "K5o", isActive: false, isCurrentError: false },
    { value: "Q5o", isActive: false, isCurrentError: false },
    { value: "J5o", isActive: false, isCurrentError: false },
    { value: "T5o", isActive: false, isCurrentError: false },
    { value: "95o", isActive: false, isCurrentError: false },
    { value: "85o", isActive: false, isCurrentError: false },
    { value: "75o", isActive: false, isCurrentError: false },
    { value: "65o", isActive: false, isCurrentError: false },
    { value: "55", isActive: false, isCurrentError: false },
    { value: "54s", isActive: false, isCurrentError: false },
    { value: "53s", isActive: false, isCurrentError: false },
    { value: "52s", isActive: false, isCurrentError: false },

    { value: "A4o", isActive: false, isCurrentError: false },
    { value: "K4o", isActive: false, isCurrentError: false },
    { value: "Q4o", isActive: false, isCurrentError: false },
    { value: "J4o", isActive: false, isCurrentError: false },
    { value: "T4o", isActive: false, isCurrentError: false },
    { value: "94o", isActive: false, isCurrentError: false },
    { value: "84o", isActive: false, isCurrentError: false },
    { value: "74o", isActive: false, isCurrentError: false },
    { value: "64o", isActive: false, isCurrentError: false },
    { value: "54o", isActive: false, isCurrentError: false },
    { value: "44", isActive: false, isCurrentError: false },
    { value: "43s", isActive: false, isCurrentError: false },
    { value: "42s", isActive: false, isCurrentError: false },

    { value: "A3o", isActive: false, isCurrentError: false },
    { value: "K3o", isActive: false, isCurrentError: false },
    { value: "Q3o", isActive: false, isCurrentError: false },
    { value: "J3o", isActive: false, isCurrentError: false },
    { value: "T3o", isActive: false, isCurrentError: false },
    { value: "93o", isActive: false, isCurrentError: false },
    { value: "83o", isActive: false, isCurrentError: false },
    { value: "73o", isActive: false, isCurrentError: false },
    { value: "63o", isActive: false, isCurrentError: false },
    { value: "53o", isActive: false, isCurrentError: false },
    { value: "43o", isActive: false, isCurrentError: false },
    { value: "33", isActive: false, isCurrentError: false },
    { value: "32s", isActive: false, isCurrentError: false },

    { value: "A2o", isActive: false, isCurrentError: false },
    { value: "K2o", isActive: false, isCurrentError: false },
    { value: "Q2o", isActive: false, isCurrentError: false },
    { value: "J2o", isActive: false, isCurrentError: false },
    { value: "T2o", isActive: false, isCurrentError: false },
    { value: "92o", isActive: false, isCurrentError: false },
    { value: "82o", isActive: false, isCurrentError: false },
    { value: "72o", isActive: false, isCurrentError: false },
    { value: "62o", isActive: false, isCurrentError: false },
    { value: "52o", isActive: false, isCurrentError: false },
    { value: "42o", isActive: false, isCurrentError: false },
    { value: "32o", isActive: false, isCurrentError: false },
    { value: "22", isActive: false, isCurrentError: false },
];

export const getComboCount = (value: string): number => {
    if (value.length === 2) return 6; // pair
    if (value.endsWith("s")) return 4; // suited
    if (value.endsWith("o")) return 12; // offsuit
    return 0;
};
